import { Injectable } from '@angular/core';
import { ModalService } from '../../../../core/modal/modal.service';
import { BusinessProcessIds } from '../../../../core/services/bp.service';
import { RcaAlarmModalComponent } from '../modals/rca-alarm-modal/rca-alarm-modal.component';
import { BaseKkmFields } from '../../../../core/modules/kkms/kkms.types';

@Injectable({
  providedIn: 'root',
})
export class KkmsModalService {
  constructor(private modalService: ModalService) {}

  openRcaAlarmModal<T extends BaseKkmFields>(kkmForm: T, processIds: BusinessProcessIds): void {
    this.modalService.openOld(RcaAlarmModalComponent<T>, {
      kkmForm,
      processIds,
    }, {
      width: '600px',
    });
  }
}
